import styles from "./SwipeArrows.module.css";

export default function SwipeArrows(props) {
  const arrowClass = props.direction === 'right' ? 'arrow-right' : 'arrow-left';

  return <div className={styles.arrows}>
    <div className={styles[arrowClass]}></div>
  </div>
};
